const Register = () => import("@/views/traffic/Register");
const ScanCode = () => import("@/views/traffic/ScanCode");
const VisitorApply = () => import("@/views/traffic/VisitorApply");

const routes = [
    {
        path: "/traffic/register",
        name: "trafficRegister",
        meta: {
            title: "访客登记"
        },
        component: Register
    },
    {
        path: "/code",
        name: "scanCode",
        meta: {
            title: "扫码入内"
        },
        component: ScanCode
    },
    {
        path: "/traffic/visitorApply",
        name: "visitorApply",
        meta: {
            title: "访客申请"
        },
        component: VisitorApply
    },
];
export default routes;
